import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Dayjs } from "dayjs";

interface SpecialPaymentInfo {
  page:number;
  rowsPerPage:number;
  filterId:string;
  participantId:string;
  transactionDate:Dayjs | null
}

const initialState: SpecialPaymentInfo = {
  page:0,
  rowsPerPage:5,
  filterId:"-1",
  participantId:"All",
  transactionDate:null
};

const createSpecialPaymentHistorySlice = createSlice({
  name: "specialPaymentHistory",
  initialState,
  reducers: {
    setCreateSpecialPaymentHistory: (
      state,
      action: PayloadAction<Partial<SpecialPaymentInfo>>
    ) => {
      return { ...state, ...action.payload };
    },
    removeSpecialPayment: () => initialState,
  },
});

export const { setCreateSpecialPaymentHistory, removeSpecialPayment } =
  createSpecialPaymentHistorySlice.actions;
export default createSpecialPaymentHistorySlice.reducer;
